import { Action, createReducer, on } from '@ngrx/store';
import { ILoaderActionPayload, LoadingState } from '../models/loader.model';
import { emailReportRuleActions } from './email-report-rule.actions';
import { EmailReportRuleItem, EmailReportRuleListResponse } from '../../../api/models';

export interface EmailReportRuleState {
  find: { state: ILoaderActionPayload; data?: EmailReportRuleListResponse };
  findOne: { state: ILoaderActionPayload; data?: EmailReportRuleItem };
  save: { state: ILoaderActionPayload; data?: EmailReportRuleItem };
  update: { state: ILoaderActionPayload; data?: EmailReportRuleItem };
  deleteRule: { state: ILoaderActionPayload };
  sendNow: { state: ILoaderActionPayload };
}

const initialState: EmailReportRuleState = {
  find: { state: { value: LoadingState.NONE } },
  findOne: { state: { value: LoadingState.NONE } },
  save: { state: { value: LoadingState.NONE } },
  update: { state: { value: LoadingState.NONE } },
  deleteRule: { state: { value: LoadingState.NONE } },
  sendNow: { state: { value: LoadingState.NONE } },
};

const reducer = createReducer(
  initialState,
  on(emailReportRuleActions.find, (state) => ({ ...state, find: { state: { value: LoadingState.LOADING } } })),
  on(emailReportRuleActions.findDone, (state, { state: s, data }) => ({ ...state, find: { state: s, data } })),
  on(emailReportRuleActions.findSetState, (state, { state: s }) => ({ ...state, find: { state: s } })),

  on(emailReportRuleActions.findOne, (state) => ({ ...state, findOne: { state: { value: LoadingState.LOADING } } })),
  on(emailReportRuleActions.findOneDone, (state, { state: s, data }) => ({ ...state, findOne: { state: s, data } })),
  on(emailReportRuleActions.findOneSetState, (state, { state: s }) => ({ ...state, findOne: { state: s } })),

  on(emailReportRuleActions.create, (state) => ({ ...state, save: { state: { value: LoadingState.LOADING } } })),
  on(emailReportRuleActions.createDone, (state, { state: s, data }) => ({ ...state, save: { state: s, data } })),
  on(emailReportRuleActions.createSetState, (state, { state: s }) => ({ ...state, save: { state: s } })),

  on(emailReportRuleActions.update, (state) => ({ ...state, update: { state: { value: LoadingState.LOADING } } })),
  on(emailReportRuleActions.updateDone, (state, { state: s, data }) => ({ ...state, update: { state: s, data } })),
  on(emailReportRuleActions.updateSetState, (state, { state: s }) => ({ ...state, update: { state: s } })),

  on(emailReportRuleActions.deleteRule, (state) => ({
    ...state,
    deleteRule: { state: { value: LoadingState.LOADING } },
  })),
  on(emailReportRuleActions.deleteRuleDone, (state, { state: s }) => ({ ...state, deleteRule: { state: s } })),
  on(emailReportRuleActions.deleteRuleSetState, (state, { state: s }) => ({ ...state, deleteRule: { state: s } })),

  on(emailReportRuleActions.sendNow, (state) => ({ ...state, sendNow: { state: { value: LoadingState.LOADING } } })),
  on(emailReportRuleActions.sendNowDone, (state, { state: s }) => ({ ...state, sendNow: { state: s } })),
  on(emailReportRuleActions.sendNowSetState, (state, { state: s }) => ({ ...state, sendNow: { state: s } })),
);

export function emailReportRuleReducer(state: EmailReportRuleState | undefined, action: Action) {
  return reducer(state, action);
}
